<template lang="pug">
  div
    div(v-if="processing")
      h1.text-center
        .spinner-border
      p.text-center Submitting your application. . .
    div(v-if="success")
      h1.text-center.text-success
        i(style="font-size: 3em;").fa.fa-check-circle
      h2.text-center Success!
      p.text-center Your membership was successfully sent. Please wait up to 3 to 5 days and be notified
      p.text-center
        button.btn.btn-outline-success(@click.prevent="navToLogin()") Go back to login
    div(v-if="failed")
      h1.text-center.text-danger
        i(style="font-size: 3em;").fa.fa-times-circle
      h2.text-center Failed!
      p.text-center Your application failed to process.
      p.text-center
        button.btn.btn-outline-secondary(@click.prevent="backToForm()") Back to Form
        button.btn.btn-outline-danger.ml-3(@click.prevent="resubmit()") Re-submit your application
</template>

<script>
export default {
  name: 'Submit',

  props: {
    processing: {
      type: Boolean,
      required: true,
    },
    failed: {
      type: Boolean,
      required: true,
    },
    success: {
      type: Boolean,
      required: true,
    },
  },

  emits: ['retry', 'navToLogin', 'backToForm'],

  setup(props, { emit }) {
    const resubmit = () => {
      emit('retry');
    };
    const navToLogin = () => {
      emit('navToLogin');
    };
    const backToForm = () => {
      emit('backToForm');
    };
    return {
      resubmit,
      navToLogin,
      backToForm,
    };
  },
};
</script>
